import { Component, OnInit, Input, Output, EventEmitter, Renderer2, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { ProductReviewService } from '../../../productReview/productReview.service';
@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit, OnDestroy {

  @ViewChild('drawer') drawer: ElementRef;

  constructor(private renderer: Renderer2,
    private _productReviewService: ProductReviewService,
  ) { }

  @Input() hideMinimizeBtn = false;
  @Input() showOverlay = true;
  @Input() isModal = false;
  @Input() drawerId;
  @Input() width?;  // if width === 'half' then show drawer on half of page in size otherwise full in size.
  @Output() backdrop = new EventEmitter<any>();
  public openDrawer = false;
  public drawerMinimized = false;
  @Input() allowBodyScroll = false;
  @Input() backdropDisable;
  @Input() drawerScroll = true;

  /*** Opens up the drawer */
  public open() {
    this.openDrawer = true;

    if (!this.allowBodyScroll) {
      this.renderer.addClass(document.body, 'overflow-hide');
    }

    if (this.drawerId === 'clickToCallDrawer') {
      this.drawer.nativeElement.classList.add('click-drawer');
    } else {
      this.drawer.nativeElement.classList.remove('click-drawer');
    }
  }

  /*** Closes the drawer */
  public close() {
    if (this.drawerId === 'clickToCallDrawer') {
      this.drawer.nativeElement.classList.remove('click-drawer');
    }
    this.openDrawer = false;
    this.renderer.removeClass(document.body, 'overflow-hide');
  }

  /*** Click on the overlay*/
  public showHideDrawer() {
    if (this.showOverlay && !this.backdropDisable) {
      this.renderer.removeClass(document.body, 'overflow-hide');
      console.log(this.backdrop);
      this.openDrawer = false;
      if (this.backdrop !== undefined) {
        this.backdrop.emit();
      }
    }
    if (window.location.href.includes('productReview') && this.drawerId === "paymentOtpDrawer") {
      this.backForOtp();
    }
  }

  ngOnInit() {
  }
  public backForOtp(): any {
    this._productReviewService.postSendMobileOTPForReviewDetails({ action: 'Back' }).subscribe(
      (response: any) => {
        console.log(response);

      },
      err => {
        console.log(err);
      }
    );
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'overflow-hide');
  }
}